import styled from 'styled-components'

export const QuestionTitleWrapper = styled.div`
  display: flex;
  align-items: baseline;
  padding-top: 5px;
`
